(() => {
	"use strict";

	document.addEventListener("DOMContentLoaded", () => {
		/*======================================
	ボタンの活性、非活性
	======================================*/
		const checkbox = document.querySelector(".js-form-agree");
		const submitBtn = document.querySelector(".js-form-submit");

		const toggleSubmitState = () => {
			submitBtn.disabled = !checkbox.checked;
		};
		toggleSubmitState();

		checkbox.addEventListener("change", toggleSubmitState);
	});
})();
